"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CreatableOption = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _i18n = require("../../../i18n/i18n");
var _OptionBase = require("./shared/OptionBase");
const CreatableOption = /*#__PURE__*/(0, _react.forwardRef)((_ref, ref) => {
  let {
    inputValue,
    optionHeight,
    ...rest
  } = _ref;
  const {
    i18n
  } = (0, _i18n.useI18n)();
  return /*#__PURE__*/_react.default.createElement(_OptionBase.OptionBase, (0, _extends2.default)({
    height: optionHeight
  }, rest, {
    ref: ref
  }), i18n._( /*i18n*/{
    comment: "When selected, this component will create a new option with the label 'inputValue' and add it to the list of options",
    id: `Add "{inputValue}"`,
    values: {
      inputValue
    }
  }));
});
exports.CreatableOption = CreatableOption;
CreatableOption.displayName = "CreatableOption";
//# sourceMappingURL=CreatableOption.js.map